import { Component, OnInit, TemplateRef } from '@angular/core';
import { UtilityService } from '../services/utility.service';
import { MasterMOMService } from '../services/master-mom.service';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import Notiflix from "notiflix";

import { alert } from '../models/MOMForm';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.css']
})
export class NotificationListComponent implements OnInit {
  login_UserID: any;
  alertList: any = [];
  disableMore: boolean = false;
  isTBT = false;
  public alertStartIndex: number = 1;
  pagetype = "MEETING";
  mid: any;
  modalMeeting: BsModalRef;
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
    noDataImage: string;
  constructor(public utilityService: UtilityService,
    public momMasterservice: MasterMOMService,
    private userService: UserService,
    private modalService: BsModalService,
    private _router: Router) { }

  ngOnInit(): void {
    this.noDataImage = this.utilityService.getnodataImage();

    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
    this.login_UserID = user.id;
    }

    this.loadAlerts();
  }

  openViewMeetingAndAttendance(template1: TemplateRef<any>, id:any,type:any) {
    ;
    this.mid = id;
    this.pagetype = type;
    this.modalMeeting = this.modalService.show(template1, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable' }, this.ngbModalOptions
    )
    );
  }
  loadValues(obj) {
    
    //this._router.navigate(['/view-page'], { queryParams: { QMId: objEncryptDecrypt.EncryptText(obj.genInfoUno), QMType: objEncryptDecrypt.EncryptText(obj.type) } });
  }
  loadAlerts() {


   Notiflix.Block.Dots('.pageloadcontainer');
    let inpValue = new alert();
    inpValue.userUno = this.login_UserID;
    this.alertStartIndex = (this.alertStartIndex == undefined || this.alertStartIndex < 1) ? 1 : this.alertStartIndex;
    inpValue.startIndex = this.alertStartIndex;
    inpValue.condition = 1;

    inpValue.maxCount = 10;
    this.momMasterservice.getAlertList(inpValue)
      .subscribe((data: any) => {
        if (this.alertStartIndex == 1) {
          this.alertList = data;
        }
        else {
          for (var i = 0; i < data.length; i++) {
            this.alertList.push(data[i]);
          }
        }


        console.log(data);
        this.disableMore = (data.length >= 10) ? false : true;
        if (data.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.alertStartIndex = this.alertStartIndex + 1;
        }
        Notiflix.Block.Remove('.pageloadcontainer', 800);

      },
        () => {
          //Called when error
          Notiflix.Block.Remove('.pageloadcontainer', 800);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        Notiflix.Block.Remove('.pageloadcontainer', 800);
      });

  }
}
